import React from 'react';
import { HotelsOutline, FlightsOutline, CarsOutline } from '@pcln/brand';
import { Box, Flex, Image } from 'pcln-design-system';
var getProductIcon = function (productType) {
  switch (productType) {
    case 'STAY':
      return React.createElement(HotelsOutline, {
        size: '32px'
      });
    case 'FLY':
      return React.createElement(FlightsOutline, {
        size: '32px'
      });
    case 'DRIVE':
      return React.createElement(CarsOutline, {
        size: '32px'
      });
  }
};
var brandImages = function (productType, imageUrl, rcBrandLogoUrl) {
  switch (productType) {
    case 'STAY':
      return React.createElement(Flex, {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
      }, React.createElement(Image, {
        height: '100%',
        width: '100%',
        alt: 'hotel-image',
        borderRadius: 'md',
        src: imageUrl
      }));
    case 'FLY':
      return React.createElement(Flex, {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }, React.createElement(Image, {
        width: '64px',
        alt: 'flight-image',
        borderRadius: 'md',
        src: imageUrl
      }));
    case 'DRIVE':
      return React.createElement(Flex, {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }, React.createElement(Image, {
        alt: 'rc-image',
        borderRadius: 'md',
        src: imageUrl
      }), rcBrandLogoUrl && React.createElement(Image, {
        alt: 'rc-brand-image',
        borderRadius: 'md',
        height: '24px',
        src: rcBrandLogoUrl
      }));
  }
};
var getMediaNode = function (productType, imageUrl, rcBrandLogoUrl) {
  if (imageUrl) {
    return brandImages(productType, imageUrl, rcBrandLogoUrl);
  } else {
    return React.createElement(Box, {
      mt: 2
    }, getProductIcon(productType));
  }
};
export default getMediaNode;